import React, { useState, useEffect, useContext } from "react";
import "popper.js";
import "bootstrap/dist/js/bootstrap";
import { useHistory } from 'react-router-dom';
// Componentes
import Foto from "../element/Foto";
import HeaderMenu from "../element/HeaderMenu";
import Menu from "./Menu";
import CardFechasVencimiento from "../element/CardFechasVencimiento";
import SkeletonCard from "../element/Skeleton";
// Contexto
import dataContext from "../context/User";
// Helper
import GetFetch from "../helper/GetFetch";
import loadMenu from "../js/main";
import Footer from './Footer';

const FechasVencimiento = () => {

  const history = useHistory();
  const dataUser = useContext(dataContext);
  let datos = localStorage.getItem('dataUser');
  const [fechas, setFechas] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {

    if (datos) {
      let cred = JSON.parse(datos);
      dataUser.token = cred.token;
      dataUser.nombre = cred.nombre;
      dataUser.carnet = cred.carnet;

      GetFetch.fechasVencimiento(dataUser.token)
        .then((fechasMateriasIT) => {
          setFechas(
            fechasMateriasIT
          );
          setCargando(false);
        }).catch(() => setCargando(false));

      loadMenu();
    } else {
      history.push("/");
    }
  }, [datos, history, dataUser]);

  // Listas derivadas para presentación (antes se contaban con variables mutadas en el render)
  const listaAntiguo = fechas.length > 0 ? fechas.filter((element) => +element.tipo === 1) : [];
  const listaTemprano = fechas.length > 0 ? fechas.filter((element) => +element.tipo === 2) : [];

  const tablaFechas = (lista) => (
    <div className="table-responsive">
      <table className="table">
        <thead>
          <tr>
            <th scope="col">Mes</th>
            <th scope="col">Fecha de vencimiento</th>
          </tr>
        </thead>
        <tbody>
          {lista.map((element) => (
            <CardFechasVencimiento
              mes={element.mes}
              vencimiento={element.vencimiento}
              key={element.id}
            />
          ))}
        </tbody>
      </table>
    </div>
  );

  return (
    // <div>

    <div className="wrapper d-flex align-items-stretch">
      <nav id="sidebar">
        <div className="custom-menu">
          <button
            type="button"
            id="sidebarCollapse"
            className="btn btn-primary"
          >
            <i className="fa fa-bars"></i>
            <span className="sr-only">Toggle Menu</span>
          </button>
        </div>
        <div className="p-4">
          <Foto foto={dataUser.carnet} alt="Foto alumno" tamanio="rounded" />

          <HeaderMenu
            carnet={dataUser.carnet}
            nombre={dataUser.nombre}
            posicion="text-center"
          />

          <Menu />

          <Footer />
        </div>
      </nav>

      <div id="content" className="p-4 p-md-5 pt-5">
        <h2 className="mb-4">Fechas de vencimiento de pagos</h2>

        {cargando ? (
          <SkeletonCard rows={6} />
        ) : (
          <div className="card">
            <div className="card-body" id='m9877'>
              <h5 className="card-title mb-3">Antiguo ingreso</h5>
              {listaAntiguo.length > 0 ? (
                tablaFechas(listaAntiguo)
              ) : (
                <p className="text-muted mb-0">
                  <i className="fa fa-clock-o mr-2" aria-hidden="true"></i>
                  Aún no hay fechas de pago definidas para <b>antiguo ingreso</b>.
                  Te invitamos a estar pendiente de esta información.
                </p>
              )}
            </div>
            <div className="card-body" id="m1233">
              <h5 className="card-title mb-3">Ingreso temprano</h5>
              {listaTemprano.length > 0 ? (
                tablaFechas(listaTemprano)
              ) : (
                <p className="text-muted mb-0">
                  <i className="fa fa-clock-o mr-2" aria-hidden="true"></i>
                  Aún no hay fechas de pago definidas para <b>nuevo ingreso (ingreso en julio)</b>.
                  Te invitamos a estar pendiente de esta información.
                </p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FechasVencimiento
